import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import Menu from 'components/global/Menu';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import useAlert from 'hooks/useAlert';

import { faCopy, faLink } from '@fortawesome/pro-regular-svg-icons';

const TrackingURL = ({ data }) => {
	const [shareMenuButtonRef, setShareMenuButtonRef] = useState(null);
	const user = useSelector((state) => state.user);
	const url = useMemo(() => new URL(window.location.href), []);
	const { showInfo } = useAlert();

	const obj = useMemo(
		() => ({
			ids: [data.ID],
			companyId: user.companyId
		}),
		[url]
	);

	const trackingMenuItems = [
		{
			label: 'openTrackingURL',
			url: 'forwardTo:',
			icon: faLink
		},
		{
			label: 'copyShipmentNumber',
			url: 'copy:',
			value: data.shipmentNumber,
			icon: faCopy
		},
		{
			label: 'copyTrackingURL',
			url: 'copy:',
			value: data.trackingURL,
			icon: faCopy
		},
		{
			label: 'copyAwbPdfURL',
			url: 'copy:',
			value: `${url.origin}/OTOAWB?enc=${btoa(JSON.stringify(obj))}`,
			icon: faCopy
		}
	];

	return data?.trackingURL !== null && data?.trackingURL !== 'null' && data?.trackingURL !== '' ? (
		<>
			<Tooltip title="clickToOpenTrackingURL" placement="top">
				<Button ref={setShareMenuButtonRef} variant="blueBorderless" fullWidth>
					<Typography color="var(--blue)" showCopyButton>
						{data?.shipmentNumber}
					</Typography>
				</Button>
			</Tooltip>

			<Menu
				placement="right-start"
				buttonRef={shareMenuButtonRef}
				hoverMode={false}
				menuItems={trackingMenuItems.map((item) => ({
					label: item.label,
					icon: item.icon,
					action: () => {
						if (item.url === 'copy:') {
							navigator.clipboard.writeText(item.value);
							showInfo({
								header: 'copiedToClipboard'
							});
							return;
						}
						window.open(data.trackingURL, '_blank');
					}
				}))}
			/>
		</>
	) : (
		<Typography showCopyButton>{data.shipmentNumber}</Typography>
	);
};

export default TrackingURL;
